<template>
  <BaseDetails class="base-details mb-5">
    <template v-slot:header>
      <h2 class="pb-3">Application Form</h2>
      <Permissioned section="bookings" :id="currentBookingId">
        <PrimaryButton
          v-if="!loading"
          :oneOfPermissions="['edit.options', 'edit.application-questions']"
          @click.native="openDialog"
          light
          dense
          shrink
          class="edit-button"
        >
          Edit
          <template v-slot:append:icon><v-icon>mdi-pencil</v-icon></template>
        </PrimaryButton>
      </Permissioned>
    </template>
    <template v-slot:body>
      <EditApplicationForm
        :bookingOptions="bookingOptions"
        v-if="isEditOpen"
        :is-open="isEditOpen"
        @close="closeDialog"
        :screeningQuestions="screeningQuestions"
        :standardQuestions="standardQuestions"
      />
      <div v-if="isLoadingQuestions || loading">
        <v-skeleton-loader v-for="i in 5" :key="i" type="list-item" />
      </div>
      <div v-else>
        <Permissioned section="bookings" :id="currentBookingId">
          <LabeledText permission="view.options" label="Profile Sections">
            <v-chip v-if="bookingOptions.requireQualifications" label>
              Qualifications
            </v-chip>
            <v-chip v-if="bookingOptions.requireExperience" label>
              Experience
            </v-chip>
            <v-chip v-if="bookingOptions.requireCv" label>
              CV
            </v-chip>
          </LabeledText>
        </Permissioned>
        <ApplicationQuestions
          title="Screening Questions"
          :questions="screeningQuestions"
        />
        <ApplicationQuestions
          title="Standard Questions"
          :questions="standardQuestions"
        />
      </div>
      <v-divider />
    </template>
  </BaseDetails>
</template>

<script>
import BaseDetails from "@/components/common/BaseDetails/BaseDetails";
import { FETCH_BOOKING_APPLICATION_QUESTIONS } from "@/store/modules/applications/actions";
import { createNamespacedHelpers } from "vuex";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import {
  GET_BOOKING_APPLICATION_QUESTIONS,
  GET_IS_LOADING_APPLICATION_QUESTIONS
} from "@/store/modules/applications/getters";
import { filter } from "lodash";
import ApplicationQuestions from "@/components/application-questions/ApplicationQuestions";
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import Permissioned from "@/components/common/Permissioned";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditApplicationForm from "@/views/bookings/EditBooking/EditApplicationForm";

const {
  mapActions: mapApplicationActions,
  mapGetters: mapApplicationGetters
} = createNamespacedHelpers(APPLICATION_NAMESPACE);

export default {
  name: "BookingApplicationQuestions",
  props: {
    loading: Boolean,
    bookingOptions: { type: Object, required: true }
  },
  components: {
    BaseDetails,
    ApplicationQuestions,
    LabeledText,
    Permissioned,
    PrimaryButton,
    EditApplicationForm
  },
  created() {
    this.fetchBookingApplicationQuestions(this.currentBookingId);
  },
  data() {
    return {
      isEditOpen: false
    };
  },
  computed: {
    ...mapApplicationGetters({
      bookingApplicationQuestions: GET_BOOKING_APPLICATION_QUESTIONS,
      isLoadingQuestions: GET_IS_LOADING_APPLICATION_QUESTIONS
    }),
    currentBookingId() {
      return this.$route.params.id;
    },
    screeningQuestions() {
      return filter(this.bookingApplicationQuestions, "required");
    },
    standardQuestions() {
      return filter(
        this.bookingApplicationQuestions,
        ({ required }) => !required
      );
    }
  },
  methods: {
    ...mapApplicationActions({
      fetchBookingApplicationQuestions: FETCH_BOOKING_APPLICATION_QUESTIONS
    }),
    openDialog() {
      this.isEditOpen = true;
    },
    closeDialog() {
      this.isEditOpen = false;
      this.fetchBookingApplicationQuestions(this.currentBookingId);
    }
  }
};
</script>
